import * as types from '../constants/ActionTypes';
import { getSearchResult } from '../../lib/crawlSearchHelper';

const getSearchObject = searchpool => ({ type: types.GET_SEARCH_OBJECT, payload: searchpool });

const updateIntentQuery = options => ({ type: types.UPDATE_INTENT_QUERY, payload: options && options.query });

const clearIntentSuggestion = () => ({ type: types.CLEAR_INTENT_SUGGESTION });

const clearAllIntent = () => ({ type: types.CLEAR_ALL_INTENT });

// get intent suggestion from Fuse.js helper
const getIntentSuggestion = (options) => {
  const suggestion = getSearchResult({ query: options && options.query, searchPool: options && options.searchPool });
  if (Array.isArray(suggestion) && suggestion.length) {
    return { type: types.GET_INTENT_SUGGESTION, payload: suggestion };
  }
  return { type: types.EMPTY_INTENT_SUGGESTION };
};

module.exports = {
  getSearchObject,
  updateIntentQuery,
  clearIntentSuggestion,
  clearAllIntent,
  getIntentSuggestion,
};
